// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "app" + "." + "ff0a2284b5b05d488cb1" + ".css";
};